import { User } from './user';
import { Warehouse } from './warehouse';
import { Packaging } from './packaging';
import { Commodity } from './commodity';

export class Stack {
  warehouse_uuid!: string;
  description?: string;
  packaging_uuid!: string;
  stack_number!: string;
  commodity_uuid!: string;
  current_stock_count?: number;
  current_stock_tonnage?: number;
  received_stock_count?: number;
  status!: string;
  user_uuid!: string;
  date_deleted?: number;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;
  warehouse?: Warehouse;
  packaging?: Packaging;
  commodity?: Commodity;

  static getSortColumns() {
    return ['stack_number', 'description', 'status'];
  }

  constructor(data: any) {
    this.warehouse_uuid = data.warehouse_uuid;
    this.description = data.description;
    this.packaging_uuid = data.packaging_uuid;
    this.stack_number = data.stack_number;
    this.commodity_uuid = data.commodity_uuid;
    this.current_stock_count = data.current_stock_count;
    this.current_stock_tonnage = data.current_stock_tonnage;
    this.received_stock_count = data.received_stock_count;
    this.status = data.status;
    this.user_uuid = data.user_uuid;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
    if (data.warehouse) {
      this.warehouse = new Warehouse(data.warehouse);
    }
    if (data.packaging) {
      this.packaging = new Packaging(data.packaging);
    }
    if (data.commodity) {
      this.commodity = new Commodity(data.commodity);
    }
  }
}
